import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Box } from "@mui/material";

import TemplateGenerator from "./components/TemplateGenerator";
import TemplateEditor from "./components/TemplateEditor";

import HtmlEditor from "./components/HtmlEditor";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";
// import TemplatePreview from "./components/TemplatePreview";

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;
console.log("API_BASE_URL:", API_BASE_URL);

function MainUi() {
  return (
    <Router>
      <Header />
      <Box sx={{ minHeight: "70vh", p: 2 }}>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/templateGenerator" element={<TemplateGenerator />} />
          <Route path="/templateEditor" element={<TemplateEditor />} />
          {/* <Route path="/templateReview" element={<TemplatePreview />} /> */}
          <Route path="/htmlEditor" element={<HtmlEditor />} />
        </Routes>
      </Box>
      {/* <Footer /> */}
    </Router>
  );
}


export default MainUi;
